import {Component, Input} from '@angular/core';
import {MyPlan} from '@ox/typings';
import {AutoDestroy} from '@ox/utils';
import {ShopDataService} from '@webu/data';
import {Subject} from 'rxjs';

@Component({
  selector: 'webu-plan-display',
  templateUrl: './plan-display.component.html'
})
export class PlanDisplayComponent {
  @AutoDestroy destroy$: Subject<void> = new Subject<void>();
  @Input() plan: MyPlan;
  @Input() type: string;
  @Input() doDisplayHeaderLine: boolean;
  @Input() productTag? : string;
  @Input() isTransitionPlan?: boolean = false;

  constructor (private shopDataService: ShopDataService){}

  isBundledPlan() {
    return this.shopDataService.getProductCopyByCode(this.plan.planCode)?.isBundledProduct ?? false;
  }

  isPrepaidExpiringSoon(plan: MyPlan): boolean {
    return Number(plan?.daysLeft) <= 60;
  }

 }
